// Page Header
export const pageHeader = {
  title: "Settings",
  isEditorView: false,
};